import { ReactComponent as ReloadIcon } from 'assett/icons/reload.svg';
import { ReactComponent as SearchHideIcon } from 'assett/icons/search_hide_icon.svg';
import { ReactComponent as SearchIcon } from 'assett/icons/search_icon.svg';
import MultipleSelect from 'components/commons/form/MultipleSelect';
import HeaderCellWithSorting from 'components/commons/list/HeaderCellWithSorting';
import { Dayjs } from 'dayjs';
import {
	handleChange,
	resetInputFilters,
	setSearch,
} from 'feature/form/formSlice';
import { setDownloadAll } from 'feature/tableSelectedItems/tableSelectedItemsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import {
	Checkbox,
	IconButton,
	TableCell,
	TableHead,
	TableRow,
} from 'styles';
import CustomMonthRangePicker from 'styles/datePicker/CustomMonthRangePicker';

const MembersBillingAggregationTableHeader = () => {
	const { search, groups } = useSelector((store: RootState) => store.form);
	const dispatch = useDispatch<AppDispatch>();

	const { planCodesDomain } = useSelector((store: RootState) => store.billing);

	const { claimClientsDomain } = useSelector((store: RootState) => store.form);

	const { downloadAll } = useSelector(
		(store: RootState) => store.tableSelectedItems,
	);

	const {
		inputAggregationBillingMonthStart,
		inputAggregationBillingMonthEnd,
		inputAggregationClient,
		inputAggregationGroups,
		inputAggregationPlanCodes,
	} = useSelector((store: RootState) => store.form);

	const handleCheckDownload = () => {
		dispatch(setDownloadAll(!downloadAll));
	};

	return (
		<TableHead>
			<TableRow>
				<TableCell>
					<Checkbox
						label=""
						onClick={handleCheckDownload}
						checked={downloadAll}
						sx={{ p: 0 }}
					/>
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting
						name="carrierName"
						overrideLabel="forms.header.carrier"
						widthBox={215}
						sortOnly
					/>
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting name="billingMonth" widthBox={215} widthInput={215}>
						<CustomMonthRangePicker
							name="billingMonth"
							dates={[
								inputAggregationBillingMonthStart,
								inputAggregationBillingMonthEnd,
							]}
							setStartDate={e =>
								dispatch(
									handleChange({
										name: 'inputAggregationBillingMonthStart',
										value: e as Dayjs,
									}),
								)
							}
							setEndDate={e =>
								dispatch(
									handleChange({
										name: 'inputAggregationBillingMonthEnd',
										value: e as Dayjs,
									}),
								)
							}
						/>
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting
						name="memberClient"
						sortField="clientName"
						widthBox={215}
						widthInput={215}
					>
						<MultipleSelect
							items={claimClientsDomain}
							name={'client'}
							value={inputAggregationClient}
							onChange={e =>
								dispatch(handleChange({ name: 'inputAggregationClient', value: e }))
							}
						/>
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting
						name="memberGroups"
						sortField="groupName"
						widthBox={215}
						widthInput={215}
					>
						<MultipleSelect
							items={groups}
							name={'group'}
							value={inputAggregationGroups}
							onChange={e =>
								dispatch(handleChange({ name: 'inputAggregationGroups', value: e }))
							}
						/>
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting
						name="planCode"
						widthBox={215}
						widthInput={215}
						overrideLabel="commons.filtersHeader.benefitLevelPlanCode"
					>
						<MultipleSelect
							items={planCodesDomain}
							name={'benefitLevelPlanCode'}
							value={inputAggregationPlanCodes}
							onChange={e =>
								dispatch(handleChange({ name: 'inputAggregationPlanCodes', value: e }))
							}
						/>
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting name="memberCount" widthBox={215} sortOnly />
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting
						name="billingRate"
						overrideLabel="forms.header.billingRateAmount"
						widthBox={215}
						sortOnly
					/>
				</TableCell>
				<TableCell>
					<HeaderCellWithSorting name="totalAmount" widthBox={215} sortOnly />
				</TableCell>
				<TableCell sx={{ minWidth: '56px', textAlign: 'center' }}>
					{search && (
						<IconButton onClick={() => dispatch(resetInputFilters())}>
							<ReloadIcon />
						</IconButton>
					)}
				</TableCell>
				<TableCell>
					<IconButton onClick={() => dispatch(setSearch(!search))}>
						{search ? <SearchHideIcon /> : <SearchIcon />}
					</IconButton>
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default MembersBillingAggregationTableHeader;
